import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';

import { usePageSettings } from '@ratehub/base-ui';

import shouldHideBackgroundCircle from '../functions/shouldHideBackgroundCircle';
import isBodyBlock from '../functions/isBodyBlock';
import BlockRenderer from './BlockRenderer';
import Layout from './Layout';


function WordpressPage({ blocks = [], blockMap, ...otherProps }) {
    const pageSettings = usePageSettings();
    const [ hideBackgroundCircle, setHideBackgroundCircle ] = useState(pageSettings.hideBackgroundImage);

    /* If a location is specified, it means it's not meant for the main body */
    const blocksWithoutLocation = blocks.filter(isBodyBlock);

    useEffect(() => {
        setHideBackgroundCircle(shouldHideBackgroundCircle(blocksWithoutLocation));
    }, []);

    return (
        <Layout
            blocks={blocks}
            hideBackgroundImage={hideBackgroundCircle}
            blockMap={blockMap}
            {...otherProps}
        >
            <BlockRenderer
                blocks={blocksWithoutLocation}
                blockMap={blockMap}
            />
        </Layout>
    );
}

WordpressPage.propTypes = {
    blocks: PropTypes.array.isRequired,
    blockMap: PropTypes.object.isRequired,
};

export default observer(WordpressPage);
